module.exports = __webpack_public_path__ + "static/media/thomas_work.276ffa42.jpg";